import ProfileInfo from 'components/ProfileInfo/ProfileInfo';
export default ProfileInfo;
